import { handleShowMessageNotification } from '../../../common/handleShowMessageNotification';

export const showMessageNotificationInfo = ({ actionInfo }) =>
    handleShowMessageNotification({ ...actionInfo, className: 'message-notification-info-push-popup' });
